import React from 'react';
import { FormattedMessage } from 'react-intl';
import { WP_EventsArray } from '../../model/models';
import { IonIcon } from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import { Link } from 'react-router-dom';
import { EventItem } from '../event/EventItem';

interface EventsListProps {
  eventsList: WP_EventsArray;
}

export const EventsTab: React.FC<EventsListProps> = ({ eventsList }) => {
  return (
    <div className="w-full text-left mt-2 px-2 md:mt-5">
      <Link
        className="hidden text-sm items-center font-bold text-primary mb-8 md:flex"
        to="/house"
      >
        <IonIcon className="text-primary mr-2" icon={chevronBackOutline} />
        <FormattedMessage id="Go back" />
      </Link>
      <h1 className="font-semibold mb-8 text-xl">
        <FormattedMessage id="All events" /> <br />
        <span className="border-after inline-block">
          <FormattedMessage id="of the house" />
        </span>
      </h1>
      <ul className="ion-list-events lg:grid lg:grid-cols-2 lg:gap-8 lg:w-full">
        {eventsList.map((event, key) => EventItem(event, '/house/events', key))}
      </ul>
    </div>
  );
};

export const EventsTabDesktop: React.FC<EventsListProps> = ({ eventsList }) => {
  return (
    <div className="w-full text-left mt-2 bg-white bg-opacity-60 p-7 border-0 rounded-3xl">
      <div className="flex flex-row justify-between items-center mb-8 ">
        <h1 className="font-semibold text-xl inline-block m-0">
          <FormattedMessage id="All events" /> <br />
        </h1>
        <Link to="/house/events" className="text-primary font-bold text-xs m-0">
          <FormattedMessage id="See more" />
        </Link>
      </div>
      <ul className="ion-list-events md:flex md:flex-col">
        {eventsList.map((event, key) => EventItem(event, '/house/events', key))}
      </ul>
    </div>
  );
};
